"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundraiseService = void 0;
const FundraiseServiceLive_1 = require("./FundraiseServiceLive");
class FundraiseService {
    static create() {
        return new FundraiseServiceLive_1.FundraiseServiceLive();
    }
}
exports.FundraiseService = FundraiseService;
//# sourceMappingURL=FundraiseService.js.map